import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ================= FETCH ================= */
export const fetchLabels = createAsyncThunk(
  "label/fetch",
  async ({ page = 1, limit = 10 }) => {
    const res = await api.get(`/api/labels?page=${page}&limit=${limit}`);
    return res.data;
  }
);

/* ================= CREATE ================= */
export const createLabel = createAsyncThunk(
  "label/create",
  async (data) => {
    const res = await api.post("/api/labels", data);
    return res.data;
  }
);

/* ================= UPDATE ================= */
export const updateLabel = createAsyncThunk(
  "label/update",
  async ({ id, name }) => {
    const res = await api.put(`/api/labels/${id}`, { name });
    return res.data;
  }
);

/* ================= DELETE ================= */
export const deleteLabel = createAsyncThunk(
  "label/delete",
  async (id) => {
    await api.delete(`/api/labels/${id}`);
    return id;
  }
);

/* ================= TOGGLE ================= */
export const toggleLabelStatus = createAsyncThunk(
  "label/toggle",
  async (id) => {
    const res = await api.patch(`/api/labels/toggle/${id}`);
    return res.data;
  }
);

const labelSlice = createSlice({
  name: "label",
  initialState: {
    labels: [],
    loading: false,
    pagination: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabels.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLabels.fulfilled, (state, action) => {
        state.loading = false;
        state.labels = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(toggleLabelStatus.fulfilled, (state, action) => {
  const updated = action.payload;

  const index = state.labels.findIndex(
    (item) => item._id === updated._id
  );

  if (index !== -1) {
    state.labels[index] = updated;
  }
});

  },
});

export default labelSlice.reducer;
